import { ViewContainerRef } from '@angular/core';
import { Field } from './field';

export abstract class FieldWrapper extends Field {
  fieldComponent: ViewContainerRef;
}



// WEBPACK FOOTER //
// ./src/core/src/templates/field.wrapper.ts